// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading_spinnerBackdrop__HpN-J {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  right: 0;
  top: 0;
  /* From https://css.glass */
  background: rgba(250, 250, 250, 0.57);
  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); */
  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);
}
.Loading_spinnerContainer__nrIl- {
  display: inline-block;
  position: relative;
  width: 240px;
  height: 240px;
}
.Loading_spinnerBackdrop__HpN-J h2 {
  font-size: 2.7rem;
  padding: 10px 0 20px 0;
}
.Loading_spinnerBackdrop__HpN-J h3 {
  font-size: 1.5rem;
  padding: 10px 0 20px 0;
}
.Loading_spinnerContainer__nrIl- div {
  position: absolute;
  width: 18px;
  height: 18px;
  background: #353e54;
  border-radius: 50%;
  animation: Loading_spinnerContainer__nrIl- 1.2s linear infinite;
}
.Loading_spinnerContainer__nrIl- div:nth-child(1) {
  animation-delay: 0s;
  top: 111px;
  left: 198px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(2) {
  animation-delay: -0.1s;
  top: 66px;
  left: 186px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(3) {
  animation-delay: -0.2s;
  top: 33px;
  left: 156px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(4) {
  animation-delay: -0.3s;
  top: 21px;
  left: 111px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(5) {
  animation-delay: -0.4s;
  top: 33px;
  left: 66px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(6) {
  animation-delay: -0.5s;
  top: 66px;
  left: 33px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(7) {
  animation-delay: -0.6s;
  top: 111px;
  left: 21px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(8) {
  animation-delay: -0.7s;
  top: 156px;
  left: 33px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(9) {
  animation-delay: -0.8s;
  top: 186px;
  left: 66px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(10) {
  animation-delay: -0.9s;
  top: 198px;
  left: 111px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(11) {
  animation-delay: -1s;
  top: 186px;
  left: 156px;
}
.Loading_spinnerContainer__nrIl- div:nth-child(12) {
  animation-delay: -1.1s;
  top: 156px;
  left: 186px;
}
.Loading_mountedLoading__szeyc {
  animation: Loading_fadeIn__ViUj6 180ms ease-out !important;
}
.Loading_unmountedLoading__L1\\+iL {
  animation: Loading_fadeOut__bsQ4Y 220ms ease-in forwards !important;
}
.Loading_mountedChildren__rFTRn {
  animation: Loading_fadeIn__ViUj6 220ms ease-out !important;
}
.Loading_unmountedChildren__nJdfF {
  animation: Loading_fadeOut__bsQ4Y 180ms ease-in forwards !important;
}
@keyframes Loading_fadeIn__ViUj6 {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
@keyframes Loading_fadeOut__bsQ4Y {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
@media all and (max-width: 1200px) {
  .Loading_spinnerBackdrop__HpN-J h2 {
    font-size: 1.8rem;
    padding: 10px 0 20px 0;
  }
  .Loading_spinnerBackdrop__HpN-J h3 {
    font-size: 1.2rem;
    padding: 10px 0 20px 0;
  }

  .Loading_spinnerContainer__nrIl- {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .Loading_spinnerContainer__nrIl- div {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #353e54;
    border-radius: 50%;
    animation: Loading_spinnerContainer__nrIl- 1.2s linear infinite;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(1) {
    animation-delay: 0s;
    top: 37px;
    left: 66px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(2) {
    animation-delay: -0.1s;
    top: 22px;
    left: 62px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(3) {
    animation-delay: -0.2s;
    top: 11px;
    left: 52px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(4) {
    animation-delay: -0.3s;
    top: 7px;
    left: 37px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(5) {
    animation-delay: -0.4s;
    top: 11px;
    left: 22px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(6) {
    animation-delay: -0.5s;
    top: 22px;
    left: 11px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(7) {
    animation-delay: -0.6s;
    top: 37px;
    left: 7px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(8) {
    animation-delay: -0.7s;
    top: 52px;
    left: 11px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(9) {
    animation-delay: -0.8s;
    top: 62px;
    left: 22px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(10) {
    animation-delay: -0.9s;
    top: 66px;
    left: 37px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(11) {
    animation-delay: -1s;
    top: 62px;
    left: 52px;
  }
  .Loading_spinnerContainer__nrIl- div:nth-child(12) {
    animation-delay: -1.1s;
    top: 52px;
    left: 62px;
  }
}
@keyframes Loading_spinnerContainer__nrIl- {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/FormContainer/Loading.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,MAAM;EACN,2BAA2B;EAC3B,qCAAqC;EACrC,+CAA+C;EAC/C,4BAA4B;EAC5B,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+DAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,UAAU;EACV,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;AACA;EACE,0DAA2C;AAC7C;AACA;EACE,mEAAoD;AACtD;AACA;EACE,0DAA2C;AAC7C;AACA;EACE,mEAAoD;AACtD;AACA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,+DAAgD;EAClD;EACA;IACE,mBAAmB;IACnB,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,QAAQ;IACR,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE;;;;IAIE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".spinnerBackdrop {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  right: 0;\r\n  top: 0;\r\n  /* From https://css.glass */\r\n  background: rgba(250, 250, 250, 0.57);\r\n  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); */\r\n  backdrop-filter: blur(7.5px);\r\n  -webkit-backdrop-filter: blur(7.5px);\r\n}\r\n.spinnerContainer {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 240px;\r\n  height: 240px;\r\n}\r\n.spinnerBackdrop h2 {\r\n  font-size: 2.7rem;\r\n  padding: 10px 0 20px 0;\r\n}\r\n.spinnerBackdrop h3 {\r\n  font-size: 1.5rem;\r\n  padding: 10px 0 20px 0;\r\n}\r\n.spinnerContainer div {\r\n  position: absolute;\r\n  width: 18px;\r\n  height: 18px;\r\n  background: #353e54;\r\n  border-radius: 50%;\r\n  animation: spinnerContainer 1.2s linear infinite;\r\n}\r\n.spinnerContainer div:nth-child(1) {\r\n  animation-delay: 0s;\r\n  top: 111px;\r\n  left: 198px;\r\n}\r\n.spinnerContainer div:nth-child(2) {\r\n  animation-delay: -0.1s;\r\n  top: 66px;\r\n  left: 186px;\r\n}\r\n.spinnerContainer div:nth-child(3) {\r\n  animation-delay: -0.2s;\r\n  top: 33px;\r\n  left: 156px;\r\n}\r\n.spinnerContainer div:nth-child(4) {\r\n  animation-delay: -0.3s;\r\n  top: 21px;\r\n  left: 111px;\r\n}\r\n.spinnerContainer div:nth-child(5) {\r\n  animation-delay: -0.4s;\r\n  top: 33px;\r\n  left: 66px;\r\n}\r\n.spinnerContainer div:nth-child(6) {\r\n  animation-delay: -0.5s;\r\n  top: 66px;\r\n  left: 33px;\r\n}\r\n.spinnerContainer div:nth-child(7) {\r\n  animation-delay: -0.6s;\r\n  top: 111px;\r\n  left: 21px;\r\n}\r\n.spinnerContainer div:nth-child(8) {\r\n  animation-delay: -0.7s;\r\n  top: 156px;\r\n  left: 33px;\r\n}\r\n.spinnerContainer div:nth-child(9) {\r\n  animation-delay: -0.8s;\r\n  top: 186px;\r\n  left: 66px;\r\n}\r\n.spinnerContainer div:nth-child(10) {\r\n  animation-delay: -0.9s;\r\n  top: 198px;\r\n  left: 111px;\r\n}\r\n.spinnerContainer div:nth-child(11) {\r\n  animation-delay: -1s;\r\n  top: 186px;\r\n  left: 156px;\r\n}\r\n.spinnerContainer div:nth-child(12) {\r\n  animation-delay: -1.1s;\r\n  top: 156px;\r\n  left: 186px;\r\n}\r\n.mountedLoading {\r\n  animation: fadeIn 180ms ease-out !important;\r\n}\r\n.unmountedLoading {\r\n  animation: fadeOut 220ms ease-in forwards !important;\r\n}\r\n.mountedChildren {\r\n  animation: fadeIn 220ms ease-out !important;\r\n}\r\n.unmountedChildren {\r\n  animation: fadeOut 180ms ease-in forwards !important;\r\n}\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n}\r\n@keyframes fadeOut {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n}\r\n@media all and (max-width: 1200px) {\r\n  .spinnerBackdrop h2 {\r\n    font-size: 1.8rem;\r\n    padding: 10px 0 20px 0;\r\n  }\r\n  .spinnerBackdrop h3 {\r\n    font-size: 1.2rem;\r\n    padding: 10px 0 20px 0;\r\n  }\r\n\r\n  .spinnerContainer {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 80px;\r\n    height: 80px;\r\n  }\r\n  .spinnerContainer div {\r\n    position: absolute;\r\n    width: 6px;\r\n    height: 6px;\r\n    background: #353e54;\r\n    border-radius: 50%;\r\n    animation: spinnerContainer 1.2s linear infinite;\r\n  }\r\n  .spinnerContainer div:nth-child(1) {\r\n    animation-delay: 0s;\r\n    top: 37px;\r\n    left: 66px;\r\n  }\r\n  .spinnerContainer div:nth-child(2) {\r\n    animation-delay: -0.1s;\r\n    top: 22px;\r\n    left: 62px;\r\n  }\r\n  .spinnerContainer div:nth-child(3) {\r\n    animation-delay: -0.2s;\r\n    top: 11px;\r\n    left: 52px;\r\n  }\r\n  .spinnerContainer div:nth-child(4) {\r\n    animation-delay: -0.3s;\r\n    top: 7px;\r\n    left: 37px;\r\n  }\r\n  .spinnerContainer div:nth-child(5) {\r\n    animation-delay: -0.4s;\r\n    top: 11px;\r\n    left: 22px;\r\n  }\r\n  .spinnerContainer div:nth-child(6) {\r\n    animation-delay: -0.5s;\r\n    top: 22px;\r\n    left: 11px;\r\n  }\r\n  .spinnerContainer div:nth-child(7) {\r\n    animation-delay: -0.6s;\r\n    top: 37px;\r\n    left: 7px;\r\n  }\r\n  .spinnerContainer div:nth-child(8) {\r\n    animation-delay: -0.7s;\r\n    top: 52px;\r\n    left: 11px;\r\n  }\r\n  .spinnerContainer div:nth-child(9) {\r\n    animation-delay: -0.8s;\r\n    top: 62px;\r\n    left: 22px;\r\n  }\r\n  .spinnerContainer div:nth-child(10) {\r\n    animation-delay: -0.9s;\r\n    top: 66px;\r\n    left: 37px;\r\n  }\r\n  .spinnerContainer div:nth-child(11) {\r\n    animation-delay: -1s;\r\n    top: 62px;\r\n    left: 52px;\r\n  }\r\n  .spinnerContainer div:nth-child(12) {\r\n    animation-delay: -1.1s;\r\n    top: 52px;\r\n    left: 62px;\r\n  }\r\n}\r\n@keyframes spinnerContainer {\r\n  0%,\r\n  20%,\r\n  80%,\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.5);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerBackdrop": `Loading_spinnerBackdrop__HpN-J`,
	"spinnerContainer": `Loading_spinnerContainer__nrIl-`,
	"mountedLoading": `Loading_mountedLoading__szeyc`,
	"fadeIn": `Loading_fadeIn__ViUj6`,
	"unmountedLoading": `Loading_unmountedLoading__L1+iL`,
	"fadeOut": `Loading_fadeOut__bsQ4Y`,
	"mountedChildren": `Loading_mountedChildren__rFTRn`,
	"unmountedChildren": `Loading_unmountedChildren__nJdfF`
};
export default ___CSS_LOADER_EXPORT___;
